import React, { useState, useRef } from "react";
import {
  message,
  Button,
  notification,
  Checkbox
} from "antd";
import { ethers } from "ethers";
import { add, differenceInDays } from "date-fns";
import areAddressesEqual from "../utils/areAddressesEqual";
import getErrorDetails from "../utils/getErrorDetails";

import "./MintPage.scss";

//const PRICE_PER_DAY = ethers.utils.parseEther("0.000392"); // $20
const PRICE_PER_DAY = ethers.utils.parseEther("0.0001567"); // $8

const MINTING_ACTIVE = true;
const CLAIMS_ACTIVE = true;

const HOME = "home";
const ABOUT_COIN_CENTER = "aboutCoinCenter";
const UTILITY = "utlity";
const HOW_IT_WORKS = "howItWorks";
const FREE_CLAIMS = "freeClaims";
const FAQS = "faqs";

const navItems = [
  { id: HOME, label: "Home" },
  { id: UTILITY, label: "NFT Utility" },
  { id: ABOUT_COIN_CENTER, label: "About Coin Center" },
  { id: FREE_CLAIMS, label: "Free Claims" },
  { id: HOW_IT_WORKS, label: "How It Works" },
  //{ id: FAQS, label: "FAQs" },
]

function BlueCheckmarkSVG() {
  return (
    <svg viewBox="0 0 600 600" width="600" height="600" xmlns="http://www.w3.org/2000/svg"><rect width="100%" height="100%" fill="white"/><g transform="translate(44, 44)"><path d="m512 268c0 17.9-4.3 34.5-12.9 49.7s-20.1 27.1-34.6 35.4c.4 2.7.6 6.9.6 12.6 0 27.1-9.1 50.1-27.1 69.1-18.1 19.1-39.9 28.6-65.4 28.6-11.4 0-22.3-2.1-32.6-6.3-8 16.4-19.5 29.6-34.6 39.7-15 10.2-31.5 15.2-49.4 15.2-18.3 0-34.9-4.9-49.7-14.9-14.9-9.9-26.3-23.2-34.3-40-10.3 4.2-21.1 6.3-32.6 6.3-25.5 0-47.4-9.5-65.7-28.6-18.3-19-27.4-42.1-27.4-69.1 0-3 .4-7.2 1.1-12.6-14.5-8.4-26-20.2-34.6-35.4-8.5-15.2-12.8-31.8-12.8-49.7 0-19 4.8-36.5 14.3-52.3s22.3-27.5 38.3-35.1c-4.2-11.4-6.3-22.9-6.3-34.3 0-27 9.1-50.1 27.4-69.1s40.2-28.6 65.7-28.6c11.4 0 22.3 2.1 32.6 6.3 8-16.4 19.5-29.6 34.6-39.7 15-10.1 31.5-15.2 49.4-15.2s34.4 5.1 49.4 15.1c15 10.1 26.6 23.3 34.6 39.7 10.3-4.2 21.1-6.3 32.6-6.3 25.5 0 47.3 9.5 65.4 28.6s27.1 42.1 27.1 69.1c0 12.6-1.9 24-5.7 34.3 16 7.6 28.8 19.3 38.3 35.1 9.5 15.9 14.3 33.4 14.3 52.4zm-266.9 77.1 105.7-158.3c2.7-4.2 3.5-8.8 2.6-13.7-1-4.9-3.5-8.8-7.7-11.4-4.2-2.7-8.8-3.6-13.7-2.9-5 .8-9 3.2-12 7.4l-93.1 140-42.9-42.8c-3.8-3.8-8.2-5.6-13.1-5.4-5 .2-9.3 2-13.1 5.4-3.4 3.4-5.1 7.7-5.1 12.9 0 5.1 1.7 9.4 5.1 12.9l58.9 58.9 2.9 2.3c3.4 2.3 6.9 3.4 10.3 3.4 6.7-.1 11.8-2.9 15.2-8.7z" fill="#1da1f2"/></g></svg>
  )
}

const CLAIMABLE_PROJECTS = [
  {
    name: "Pinyotta",
    label: "Pinyottas - 1 year",
    key: "Pinyottas",
    days: 365,
    checked: false,
    entry: ""
  },
  {
    name: "Pinyotta Check",
    label: "Pinyotta Checks - 6 months",
    key: "PinyottaChecks",
    days: 180,
    checked: false,
    entry: ""
  },
  {
    name: "Phrump",
    label: "Phrumps - 6 months",
    key: "Phrumps",
    days: 180,
    checked: false,
    entry: ""
  },
  {
    name: "q00tant",
    label: "q00tants - 6 months",
    key: "q00tants",
    days: 180,
    checked: false,
    entry: ""
  },
  {
    name: "q00nicorn",
    label: "q00nicorns - 6 months",
    key: "q00nicorns",
    days: 180,
    checked: false,
    entry: ""
  },
  {
    name: "The Daily Gwei : One-Year Anniversary NFT",
    label: "The Daily Gwei : One-Year Anniversary NFT - 6 months",
    key: "tdg",
    days: 180,
    checked: false,
    entry: ""
  },
];

export default function MintPage(props) {
  const {
    address,
    writeContracts,
    onClickConnect,
    blockExplorer,
  } = props;

  const monthInput = useRef();
  const [months, setMonths] = useState(6);
  const [selectedNavItem, setSelectedNavItem] = useState(HOME);
  const [claimableProjects, setClaimableProject] = useState(CLAIMABLE_PROJECTS);
  const [donationAmount, setDonationAmount] = useState();

  function connect() {
    onClickConnect();
  }

  async function mint() {
    const months = parseInt(monthInput.current.value);
    if(!months) {
      setMonths(0);
      return;
    }

    const now = new Date();
    const endDate = add(now, {months: months});
    const days = differenceInDays(endDate, now);
    
    const cost = ethers.BigNumber.from(days).mul(PRICE_PER_DAY);
    //console.log(writeContracts.BlueCheckmark.address);
    //console.log(days);
    //console.log(cost.toString())
    try {
      const tx = await writeContracts.BlueCheckmark.mint(days, {
        value: cost.toString()
      });
      message.loading({
        key: tx.tx,
        content: (
          <div>
            <div>Transaction sent. View on <a href={blockExplorer + '/tx/' + tx.hash} target="_blank" rel="noreferrer">Etherscan</a></div>
          </div>
        )
      }
        
      )
      tx.wait(1).then(receipt => {
        console.log(receipt)
        if(receipt && receipt.events) {
          for(let i = 0; i < receipt.events.length; i++) {
            const event = receipt.events[i];
            if(event.event === "Transfer") {
              message.success({
                key: tx.tx,
                content: (
                  <div>
                    <div>You now have a Blue Checkmark! Just like your favorite Twitter personalities!</div>
                  </div>
                ),
                duration: 10,
              });
              break;
            }
          }
        }
      });
    } catch(e) {
      console.log(e);
      let details = getErrorDetails(e);
      notification.open({
        message: 'Error',
        description: <div>
          Something went wrong creating the transaction for you to sign :(
          {details && <p><br/>{details}</p>}
        </div>
      });
    }
  }

  function handleClaimableCheckboxChange(project) {
    const newClaimableProjects = [];
    claimableProjects.forEach(claimableProject => {
      if(claimableProject === project) {
        newClaimableProjects.push({
          ...project,
          checked: !project.checked
        });
      } else {
        newClaimableProjects.push(claimableProject);
      }
    });
    setClaimableProject(newClaimableProjects);
  }

  function handleClaimableProjectTokenIdInputChange(event, project) {
    const inputValue = event.target.value;
    const restricted = inputValue.replace(/[^0-9 ,]/g, '');
    const newClaimableProjects = [];
    claimableProjects.forEach(claimableProject => {
      if(claimableProject === project) {
        newClaimableProjects.push({
          ...project,
          entry: restricted,
        });
      } else {
        newClaimableProjects.push(claimableProject);
      }
    });
    setClaimableProject(newClaimableProjects);
  }

  async function claim() {
    function parseEntries() {
      // Convert the text the user input (`entry`) into an array of NFT token ids
      // and attach them to the claimableProjects objects as the `ids` field.
      const projectsAndIds = [];
      claimableProjects.forEach(project => {
        if(!project.checked) {
          return;
        }
        const entry = project.entry;
        const ids = entry.replace(/\s/g, "") // remove spaces
              .split(",") // split on commas
              .filter(val => !isNaN(val) && val !== "") // filter non-empty and non-NaN values
              .map(val => parseInt(val, 10)); // convert to integers
        if(ids.length > 0) {
          projectsAndIds.push({
            ...project,
            ids: ids
          })
        }
      });
      return projectsAndIds;
    }
  
    async function validateProjectsAndIds(projectsAndIds) {
      // Make sure the user has entered some token IDs
      let idCount = 0;
      for(let i = 0; i < projectsAndIds.length; i++) {
        const project = projectsAndIds[i];
        const { ids } = project;
        idCount += ids.length;
      }
      if(idCount === 0) {
        notification.open({
          message: `Enter the token IDs for at least one of the claimable projects you own.`
        });
        return;
      }

      // Check if the user owns each NFT they specified and if each of them is still claimable.
      for(let i = 0; i < projectsAndIds.length; i++) {
        const project = projectsAndIds[i];
        const { ids } = project;
        const {
          address: contractAddress,
          contract
        } = writeContracts[project.key];

        console.log(contractAddress)
  
        for(let j = 0; j < ids.length; j++) {
          const id = ids[j];
          try {
            const tokenOwner = await contract.ownerOf(id);
            if(!areAddressesEqual(address, tokenOwner)) {
              notification.open({
                message: `You do not own ${project.name} #${id}`
              });
              return false;
            }
          } catch(e) {
            const details = getErrorDetails(e);
            notification.open({
              message: 'Error',
              description: <div>
                <p>Something went wrong checking if you own {project.name} #{id}.</p>
                <p>Try removing that token ID and clicking "Claim" again.</p>
                <p>{details && <p><br/>{details}</p>}</p>
              </div>,
            });
            return false;
          }
  
          try {
            const claimable = await writeContracts.BlueCheckmark.isClaimAvailable(contractAddress, id);
            if(!claimable) {
              notification.open({
                message: `The Blue Checkmark for ${project.name} #${id} has already been claimed.`,
              });
              return false;
            }
          } catch (e) {
            const details = getErrorDetails(e);
            notification.open({
              message: 'Error',
              description: <div>
                <p>Something went wrong checking if the Blue Checkmark for {project.name} #{id} is still claimable.</p>
                <p>Try removing that token ID and claiming again.</p>
                <p>{details && <p><br/>{details}</p>}</p>
              </div>,
            });
            return false;
          }
          //console.log(`${project.name} #${id} is claimable`);
        }
      }
      return true;
    }
  
    function extractProjectAddressesAndTokenIds(projectsAndIds) {
      const projectsAddressesToSubmit = [];
      const tokenIdsToSubmit = [];
      for(let i = 0; i < projectsAndIds.length; i++) {
        const project = projectsAndIds[i];
        const { ids } = project;
        const {
          address: contractAddress,
        } = writeContracts[project.key];
        
        for(let j = 0; j < ids.length; j++) {
          projectsAddressesToSubmit.push(contractAddress);
          tokenIdsToSubmit.push(ids[j]);
        }
      }
      return [projectsAddressesToSubmit, tokenIdsToSubmit];
    }
  
    async function executeClaimTransaction(projectAddresses, tokenIds, donationAmount) {
      try {
        const tx = await writeContracts.BlueCheckmark.claimFromProjects(
          projectAddresses,
          tokenIds,
          { value: ethers.utils.parseEther(donationAmount ? donationAmount : "0") }
        );

        message.loading({
          key: tx.tx,
          content: (
            <div>
              <div>Transaction sent. View on <a href={blockExplorer + '/tx/' + tx.hash} target="_blank" rel="noreferrer">Etherscan</a></div>
            </div>
          )
        });

        tx.wait(1).then(receipt => {
          console.log(receipt)
          if(receipt && receipt.events) {
            for(let i = 0; i < receipt.events.length; i++) {
              const event = receipt.events[i];
              if(event.event === "Transfer") {
                const successMessage = tokenIds.length === 1
                  ? "You've claimed a Blue Checkmark. Take good care of it!"
                  : `You've claimed ${tokenIds.length} Blue Checkmarks. Take good care of them!`
                message.success({
                  key: tx.tx,
                  content: (
                    <div>
                      <div>{successMessage}</div>
                    </div>
                  ),
                  duration: 10,
                });
                break;
              }
            }
          }
        });
      } catch(e) {
        console.log(e);
        let details = getErrorDetails(e);
        notification.open({
          message: 'Error',
          description: <div>
            Something went wrong creating the transaction for you to sign :(
            {details && <p><br/>{details}</p>}
          </div>
        });
      }
    }

    const projectsAndIds = parseEntries();
    const areProjectIdsValid = await validateProjectsAndIds(projectsAndIds);
    if(!areProjectIdsValid) {
      return;
    }

    const [
      projectsAddressesToSubmit,
      tokenIdsToSubmit,
    ] = extractProjectAddressesAndTokenIds(projectsAndIds);

    executeClaimTransaction(projectsAddressesToSubmit, tokenIdsToSubmit, donationAmount);
  }

  function handleDonationInputChange(event) {
    const inputValue = event.target.value;
    const restricted = inputValue.replace(/[^0-9/.]/g, '');
    setDonationAmount(restricted);
  }

  async function donate() {
    try {
      const tx = await writeContracts.BlueCheckmark.signer.sendTransaction({
        to: writeContracts.BlueCheckmark.address,
        value: ethers.utils.parseEther(donationAmount)
      });
      tx.wait(1).then(receipt => {
        console.log(receipt)
        message.success(
          <div>
            <div>Thank you for donating to Coin Center via Blue Checkmark!</div>
          </div>, 5
        );
      });
    } catch(e) {
      console.log(e);
      let details = getErrorDetails(e);
      notification.open({
        message: 'Error',
        description: <div>
          Something went wrong creating the transaction for you to sign :(
          {details && <p><br/>{details}</p>}
        </div>
      });
    }
  }

  const now = new Date();
  const endDate = add(now, {months: months});
  const days = differenceInDays(endDate, now);
  const cost = ethers.BigNumber.from(days).mul(PRICE_PER_DAY);

  return (
    <div className="MintPage">
      <nav>
        { navItems.map(navItem => {
          return (
            <div
              key={navItem.id}
              className={`nav-item ${selectedNavItem === navItem.id ? 'selected' : ''}`}
              onClick={() => setSelectedNavItem(navItem.id)}
            >
              <BlueCheckmarkSVG/>
              {navItem.label}
            </div>
          )
        }) }
      </nav>

      { selectedNavItem === HOME &&
        <div className="dialog intro">
          <p>Blue Checkmark is a subscription NFT that trustlessly funds <a href="https://www.coincenter.org/" target="_blank" rel="noreferrer">Coin Center</a>. Read the announcement thread <a href="https://twitter.com/MikeSylphDapps/status/1628441376471019526" target="_blank" rel="noreferrer">here</a>.</p>

          <p className="bold">Blue Checkmarks were originally priced at $20/month (<a href="https://twitter.com/Dexerto/status/1587118636623446017" target="_blank" rel="noreferrer">an, IMO, fair price for a checkmark</a>), but were repriced to $8/month after <a href="https://etherscan.io/tx/0x0a4921ae76d8b8da565837081edb36e6bf184284ccc149d49ecf862059b99b00" target="_blank" rel="noreferrer">renowned on-chain horror novelist 0xth0mas</a> (aka <a href="https://twitter.com/0xjustadev" target="_blank" rel="noreferrer">@0xjustadev</a>) <a href="https://etherscan.io/tx/0x6db24de648bef6047a4425607bad97addb8bed0bdc0ce773363fee25965ea11d" target="_blank" rel="noreferrer">threatened to leave the platform</a>. We settled on $8/month. I hope <a href="https://etherscan.io/tx/0xa94d07dcc1e8fe77574b2ca0387ef551ff081d0bbacde5c70053eef66ee58b05" target="_blank" rel="noreferrer">you're all happy</a>.</p>

          <p>No one could have seen this coming.</p>

          <div className="tweet">
            <img src="./images/king-tweet.png" alt=""/>
          </div>
          
          <p>How long will minting be open? Hard to say. Maybe we'll do a poll. <a href="https://twitter.com/elonmusk/status/1604617643973124097" target="_blank" rel="noreferrer">I will abide by the results</a>.</p>
            { MINTING_ACTIVE &&
              <div className="mint-controls">
                { !address &&
                  <Button type="primary" shape="round" onClick={connect}>Connect wallet to mint</Button>
                }
                { address &&
                  <div className="minter">
                    <div className="month-selector">
                      <span>How many months?</span>
                      <input
                        ref={monthInput}
                        type="number"
                        min="1"
                        max="120"
                        value={months}
                        onChange={e => setMonths(e.target.value)}
                      />
                    </div>
                    <div>
                      { months < 6 &&
                        <div
                          style={{
                            fontSize: '18px',
                            marginBottom: '10px'
                          }}
                        >
                          Include { 6 - months } more { 6 - months === 1 ? 'month' : 'months' } for a shot at a <span className="gray">gray</span> or <span className="gold">gold</span> checkmark.
                        </div>
                      }
                      <span style={{fontSize: '18px', marginRight: '5px'}}>Donate {ethers.utils.formatEther(cost)} ETH to Coin Center and </span>
                      <Button
                        type="primary"
                        shape="round"
                        disabled={!months}
                        onClick={mint}
                      >
                        Mint
                      </Button>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
        
        { selectedNavItem === ABOUT_COIN_CENTER &&
          <div>
            <p><a href="https://www.coincenter.org/" target="_blank" rel="noreferrer">Coin Center</a> is non-profit advocacy group focused on the public policy issues facing our industry. They defend individuals who want to build on top of and use crypto.</p>
            <p>If we are going stop ill-informed regulations from coming for crypto (*cough* SBF's DCCPA bill *sputter* treating staking as a security *cough* sanctions on smart contracts *wheeze*) Coin Center will play a role in that effort.</p>
            <p>If you'd like to donate to Coin Center and have it tracked as one of the contributions made through Blue Checkmark but don't care about getting your own Blue Checkmark in return, you can do that here:</p>
            <div className="donate-controls">
              { !address &&
                <Button type="primary" shape="round" onClick={connect}>Connect wallet to donate</Button>
              }
              { address &&
                <>
                  <input
                    placeholder="0"
                    value={donationAmount}
                    onChange={event => handleDonationInputChange(event)}
                  />
                  ETH
                  <Button type="primary" shape="round" onClick={donate} disabled={!donationAmount}>Donate</Button>
                </>
              }
            </div>
          </div>
        }
        { selectedNavItem === UTILITY &&
          <div>
            <p>Blue Checkmark's utility is basically the same as Elon's blue checkmark:</p>
            <div className="utilities">
              <div className="utility">
                <p>Lets you add a blue checkmark to your Twitter profile...<br/><br/>as your PFP!*</p>
              </div>
              <div className="utility">
                <p>Adds confusion to Twitter!<br/><br/>If we're all blue checks how can we tell each other apart?</p>
              </div>
              <div className="utility">
                <p>Doesn't really change your Twitter experience otherwise!</p>
              </div>
            </div>
            <p>But what sets Blue Checkmark apart is its most important feature: Helping to fund <a href="https://www.coincenter.org/" target="_blank" rel="noreferrer">Coin Center</a> so they can continue to advocate on behalf of our entire industry.</p>
          </div>
        }
        { selectedNavItem === HOW_IT_WORKS &&
          <div>
            <p>When you mint a Blue Checkmark you choose how many months you want to prepay and send a corresponding amount of ETH to the Blue Checkmark contract's <span className="code">mint</span> function (done seamlessly through this site).</p>
            <p>If you load up with at least a six-month subscription, there is a random chance you get a <span className="gray">gray</span> (4%) or <span className="gold">gold</span> (1%) checkmark.</p>
            <p>Anyone can call the <span className="code">donateBalance</span> function, which transfers the balance of the Blue Checkmark contract to <a href="https://etherscan.io/address/0x15322B546e31F5Bfe144C4ae133A9Db6F0059fe3" target="_blank" rel="noreferrer">Coin Center's donation address</a>. There is no other way for ether to move out of the contract.</p>
            <p>If your subscription lapses, your Blue Checkmark is eligible to be burned by anyone who wants to pony up the gas and call <span className="code">burn</span>.</p>
            <p>You can top off your subscription before or after the expiration date (as long as your Blue Checkmark has not yet been burned) using <span className="code">extendSubscription</span>.</p>
            <p>The <span className="code">tokenURI</span> function calculates how much time is left in the Blue Checkmark subscription and generates an SVG on-the-fly. The more time that remains, the larger the image. Is your size size?</p>
          </div>
        }
        { selectedNavItem === FREE_CLAIMS &&
          <div>
            {/*
            <p><a href="https://pinyottas.com/" target="_blank" rel="noreferrer">Pinyotta</a> holders can claim a free Blue Checkmark with a one year subscription (dated at the time they claim) for each pinyotta they hold. This is not snapshot-based.</p>
            <p>q00nicors, q00tants, and Lazy Lions holders can claim a free Blue Checkmark with a three month expiration date for each NFT they hold from those collections, again not snapshot-based.</p>
            */}
            <p>Holders of certain NFT collections are eligible to claim Blue Checkmarks preloaded with subscriptions spanning a number of months with the option of making a donation when claiming. <b style={{color: '#990000'}}>The optional donation does NOT increase the subscription duration for the claimed Blue Checkmarks.</b></p>
            <p>Projects include other <a href="https://sylphdapps.com" target="_blank" rel="noreferrer">Sylph Dapps</a> collections (<a href="https://pinyottas.com/" target="_blank" rel="noreferrer">Pinyottas</a>, <a href="https://zora.co/collections/0xb5a7e28cd2bf8897d6d1bd4f05ad8cc7ef457bb9" target="_blank" rel="noreferrer">Pinyotta Checks</a>, and <a href="https://sylphdapps.com/phrumps" target="_blank" rel="noreferrer">Phrumps</a>), <a href="https://twitter.com/0xQuit" target="_blank" rel="noreferrer">0xQuit</a>'s <a href="https://opensea.io/collection/q00tants" target="_blank" rel="noreferrer">q00tants</a> and <a href="https://opensea.io/collection/q00nicorns" target="_blank" rel="noreferrer">q00nicorns</a>, and Anthony Sassano's <a href="https://opensea.io/collection/the-daily-gwei-1-year-anniversary-nft" target="_blank" rel="noreferrer">The Daily Gwei - One-Year Anniversary NFT</a>.</p>
            <p><b>Take good care of your free claims by keeping their subscriptions up to date or find them new homes with someone who can.</b></p>

            { CLAIMS_ACTIVE &&
              <>
                <div className="claim-controls">
                  { !address &&
                    <div className="center">
                      <Button type="primary" shape="round" onClick={connect}>Connect wallet to claim</Button>
                    </div>
                  }
                  { address &&
                    <>
                      <hr style={{borderBottom: 'none'}}/>
                      <p className="bold">Free Claims:</p>
                      <p>Select the projects you hold and enter your NFTs' IDs to claim a corresponding number of Blue Checkmarks preloaded with that project's subscription duration.</p>
                      <p>Note that each eligible NFT only gets one free claim. If a previous owner already claimed an item's Blue Checkmark, that NFT is not eligible for another free claim. The claim process will check this for you before you submit your transaction.</p>
                      <div className="claimable-rows">
                        { claimableProjects.map(project => {
                          return (
                            <div
                              className="claimable-row"
                              key={project.key}
                            >
                              <div className="checkbox-container">
                                <Checkbox
                                  checked={project.checked}
                                  onChange={() => handleClaimableCheckboxChange(project)}
                                >
                                  {project.label}
                                </Checkbox>
                              </div>
                              { project.checked &&
                                <input
                                  placeholder="Token IDs (e.g. 1,2,3)"
                                  value={project.entry}
                                  onChange={event => handleClaimableProjectTokenIdInputChange(event, project)}
                                />
                              }
                            </div>
                          )
                        })}
                      </div>
                      <div className="center donate-controls">
                        Include a donation of
                        <input
                          placeholder="0"
                          value={donationAmount}
                          onChange={event => handleDonationInputChange(event)}
                        /> ETH and
                        <Button type="primary" shape="round" onClick={claim}>Claim</Button>
                      </div>
                      <hr style={{borderBottom: 'none'}}/>
                    </>
                  }
                </div>
              </>
            }
          </div>
        }
        { selectedNavItem === FAQS &&
          <div>
            <h3>What is the max supply?</h3>
            <p>There is none. Go nuts! The free claims are great to hold on to as gifts for friends who haven't made the leap to Web3 yet but might make the leap in the next cycle.</p>
            {/*<h3>Isn't a $20 NFT on Ethereum kinda stupid because of those high gas prices?</h3>
            <p>Otherside was 5 ETH in gas + APE, and Goblintown was free, and you minted both of those, so the way I see it anything goes. 🙃</p>
        <p>Tip: Gas fees are about the same regardless of the number of months you include in your subscription, so consider buying a larger subscription now to save you from having to spend more gas to extend your subscription sooner. As a bonus, this gets more ETH to Coin Center up front.</p>*/}
            <h3>Isn't $20 still kind of expensive for a blue checkmark?</h3>
            <p>If a renowned horror novelist puts up a stink I might be willing to negotiate.</p>
          </div>
        }

        <div className="img-container">
          <BlueCheckmarkSVG/>
          <BlueCheckmarkSVG/>
          <BlueCheckmarkSVG/>
          <BlueCheckmarkSVG/>
          <BlueCheckmarkSVG/>
        </div>


        { selectedNavItem === UTILITY &&
          <>
            <hr/>
            <div className="footnotes">
              <p className="footnote">* Blue Checkmarks are on-chain SVGs, which don't work with Twitter's hexagon PFP integration, so you'll have to use the traditional circle PFP.</p>
            </div>
            <hr/>
          </>
        }
        

        <div className="credits">
          <p className="center">Built with 💙 for decentralization and trustlessness by <a href="https://twitter.com/MikeSylphDapps" target="_blank" rel="noreferrer">mike.sylphdapps.eth</a>.</p>
          {/*<p className="center">If you appreciate this, consider minting a <a href="https://pinyottas.com" target="_blank" rel="noreferrer">pinyotta</a>.</p>*/}
          <p className="center">You can see my other work at <a href="https://sylphdapps.com" target="_blank" rel="noreferrer">Sylph Dapps</a>.</p>
        </div>
      </div>
  );
};
